exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".url-background-image{background-repeat:no-repeat;background-position:center}.url-background-image__contain{background-size:contain}.url-background-image__cover{background-size:cover}", ""]);
